import {
    DatasetPanoramasDTO,
    DatasetPanoramasResponse,
    GViewDTO,
    GViewInfo,
    ProjectDatasetDTO,
    ProjectDatasetResponse,
    ShareDataDto,
    ShareInfo,
} from './types';
import { API_PATHS } from './apiPaths';
import { GET } from './baseQueries';

// @TODO pass token through http client

export const API_HANDLERS = {
    PSP: {
        GVIEW: {
            GET({ id, token }: GViewDTO) {
                return GET<GViewInfo>(API_PATHS.PSP.GVIEW.BY_ID(id), {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            },
        },
        PROJECT: {
            DATASET({ projectId, token }: ProjectDatasetDTO) {
                return GET<ProjectDatasetResponse>(API_PATHS.PSP.PROJECT.DATASET(projectId), {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        state: 20,
                    },
                });
            },
        },
        DATASET: {
            PANORAMAS({ projectId, datasetId, token }: DatasetPanoramasDTO) {
                return GET<DatasetPanoramasResponse>(API_PATHS.PSP.DATASET.PANORAMAS(projectId, datasetId), {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            },
        },
        VIEW: {
            SHARE_DATA({ pucKey }: ShareDataDto) {
                return GET<ShareInfo>(API_PATHS.PSP.VIEW.SHARE_DATA(pucKey));
            },
        },
    },
};
